const doc = [({"en":({"js":({"admin":({"logs":({"details":({"reimbursement":({"update":({"changed_from_to":"%{attribute} was changed %{from} to %{to}."})})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;